// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__LRSYZ","spin":"PrintLink_spin__Npqme"};